import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {connect} from 'react-redux';
import SongSetupSuccess from '../Shared/SongSetupSuccess/SongSetupSuccess';
import { goToPage, setTitle,pageLoaded } from '../fundialSlice';
import { Container, Col, Row } from 'reactstrap';


const SongSetupSuccessPage = (props) => {

useExtendedEffect((runSideEffects) => { 
  window.scrollTo(0, 0);

  if (runSideEffects()) {
    props.setTitle({titleBold: "בחירת המתנה נעימה" , titleRegular: ""});
    props.pageLoaded();
  }
}, []);


function onClickBtn(){
  props.goToPage({page: 'lobbyPage'});
}

  function view() {
    return (
      <Row className="justify-content-md-center">
        <Col xs='12' sm='12' md='6'>
            <SongSetupSuccess onClickBtn={onClickBtn} type={props.successType}/>
        </Col>
      </Row>
    )
  }

  return (
    <div className='song-setup-success-page'>
      {view()}
    </div>
  );
};


const mapStateToProps = (state) => {
    return {
      successType: state.fundialPage.pages.songSetupSuccessPage.type
    };
  };
  
  const mapDispatchToProps = {
    goToPage,
    setTitle,
    pageLoaded
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(SongSetupSuccessPage);